import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import PageLayout from '../../layouts/PageLayout';
import { adminNotificationAPI } from '../../services/adminNotification';
import { enableNativeNotifications, pushPermission } from '../../utils/nativeNotifications';

// Hộp thư app On Admin: tin Telegram nhóm/kênh (báo cáo quản lý) máy chủ chép sang, mới nhất trước.
export default function NotificationPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [permission, setPermission] = useState('unsupported');

  const load = useCallback(async (before) => {
    setLoading(true);
    setFailed(false);
    try {
      const page = (await adminNotificationAPI.list(before))?.items || [];
      setItems((current) => (before ? [...current, ...page] : page));
      setHasMore(page.length === 50);
    } catch {
      setFailed(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    pushPermission()
      .then(setPermission)
      .catch(() => {});
    const refresh = () => load();
    window.addEventListener('admin:notification', refresh);
    return () => window.removeEventListener('admin:notification', refresh);
  }, [load]);

  const open = (item) => {
    if (!item.read_at) {
      adminNotificationAPI.markRead(item.id).catch(() => {});
      setItems((current) => current.map((x) => (x.id === item.id ? { ...x, read_at: new Date().toISOString() } : x)));
    }
    if (item.path && item.path !== '/notification') navigate(item.path);
  };

  const enable = async () => {
    try {
      await enableNativeNotifications();
    } finally {
      setPermission(await pushPermission());
    }
  };

  return (
    <PageLayout>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">Thông báo</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link
                to="/"
                className="mc-breadcrumb-link"
              >
                Trang chủ
              </Link>
            </li>
            <li className="mc-breadcrumb-item">Thông báo</li>
          </ul>
        </div>
      </div>
      <div className="mc-card">
        <div className="mc-card-header">
          <h4 className="mc-card-title">Tất cả thông báo</h4>
          {permission !== 'unsupported' && permission !== 'granted' && (
            <button
              type="button"
              className="mc-btn primary sm"
              onClick={enable}
            >
              <i className="material-icons">notifications_active</i>
              <span>Bật thông báo trên điện thoại</span>
            </button>
          )}
        </div>
        {failed && <p className="mc-notify-empty">Không tải được thông báo.</p>}
        {!failed && !loading && !items.length && <p className="mc-notify-empty">Chưa có thông báo.</p>}
        <ul className="mc-notify-list">
          {items.map((item) => (
            <li
              key={item.id}
              className={`mc-notify-item ${item.read_at ? '' : 'unread'}`}
            >
              <button
                type="button"
                className="mc-notify-content mc-notify-button"
                onClick={() => open(item)}
              >
                <div className="mc-notify-meta">
                  <span className="mc-notify-text">{item.message}</span>
                  <small>{moment(item.created_at).format('HH:mm DD/MM/YYYY')}</small>
                </div>
              </button>
            </li>
          ))}
        </ul>
        {hasMore && (
          <button
            type="button"
            className="mc-btn primary sm"
            disabled={loading}
            onClick={() => load(items[items.length - 1]?.id)}
          >
            Xem thêm
          </button>
        )}
      </div>
    </PageLayout>
  );
}
